/**
 * Per-league rules for grouping/sorting teams in the All Leagues grid.
 * Add entries here when a league needs custom ordering without branching in getTeamsByLeague.
 */
export type DivisionSortRule = 'default' | 'afcBeforeNfc';

const LEAGUE_DIVISION_SORT: Partial<Record<string, DivisionSortRule>> = {
  nfl: 'afcBeforeNfc',
};

export const getDivisionSortRuleForLeague = (
  apiLeagueCode: string
): DivisionSortRule =>
  LEAGUE_DIVISION_SORT[apiLeagueCode.toLowerCase()] ?? 'default';
